import { Box } from '@mui/material';

const Banner = ({theme, changeTheme}) => (
  <Box 
    className="BannerBox"
    sx={{
      
    }}
    onClick={changeTheme}
  >
    <img
      src={`/images/blogbanner${theme}.png`}
      alt='banner'
      style={{
        maxWidth: '100%',
        height: 'auto',
        display: 'block' 
      }}
    />
  </Box>
);

export default Banner;